<template>
  <div class="homeContent z1200">
    <div v-show="!isSeting&&!ispayShow" class="topshow">
      <div class="myMsg1">
        <div class="userImg">
          <img :src="userData1.USER_PHOTO" alt="">
        </div>
        <div class="tipname">
          <p>
            {{ userData1.USER_NICK_NAME }}
            <span class="settingBtn" @click="goseting"><svg-icon icon-class="pen" />账号设置</span>
            <span style="float: right;color: #ed4040;margin-right: 20px;cursor: pointer" @click="outlogin">退出</span>
          </p>
          <p class="usertag">
            {{ userData1.SIGNATURE }}
          </p>
          <div class="usercount">
            <span style="margin-right: 80px">
              <span class="iconbgc1">
                <svg-icon icon-class="phone" />
              </span>
              <span class="usercount_text">已认证</span>
              <span class="btn_user" @click="handelPhone">更换</span>
            </span>
            <span>
              <span class="iconbgc2">
                <svg-icon icon-class="wxicon" />
              </span>
              <span class="usercount_text">已绑定</span>
              <span class="btn_user" @click="handelwx">更换</span>
            </span>
          </div>
        </div>
      </div>
      <div class="myMsg2">
        <div class="myMsg2_p1">
          <p class="lefticon">
            <svg-icon icon-class="shouru" />
            收益
          </p>
          <div class="rightnum">
            <p class="rightnum_p">
              <span>今日</span>
              <span class="num">{{ userData2.incomeToday }}</span>
            </p>
            <p class="rightnum_p rightnum_p_2">
              <span>累计</span>
              <span class="num">{{ userData2.incomeCumulative }}</span>
            </p>
          </div>
        </div>
        <div class="myMsg2_p2">
          <span>账户余额：￥</span>
          <span class="moneynum">{{ userData2.incomeBalance }}</span>
          <span class="moneybtn moneybtn1" @click="isPay">充值</span>
          <span class="moneybtn moneybtn2" @click="tixian">提现</span>
        </div>
      </div>
      <div class="myMsg3">
        <div class="myMsg2_p1">
          <p class="lefticon">
            <svg-icon icon-class="jifen" />
            积分
          </p>
          <div class="rightnum">
            <p class="rightnum_p">
              <span>今日</span>
              <span class="num">{{ userData2.integralsToday }}</span>
            </p>
            <p class="rightnum_p rightnum_p_2">
              <span>累计</span>
              <span class="num">{{ userData2.integralsCumulative }}</span>
            </p>
          </div>
        </div>
        <div class="myMsg2_p2">
          <span>当前积分：</span>
          <span class="moneynum">{{ userData2.integralsBalance }}</span>
          <a class="myMsg3_p3" href="/user?index=6">
            <img :src="geticon" alt="">
            <span>赚取积分</span>
          </a>
        </div>
      </div>
    </div>
    <div v-show="!isSeting&&!ispayShow" class="showlist">
      <!--<div class="showli showli1">-->
      <!--<div class="tipcode">-->
      <!--<img :src="codeimg" alt="" class="codes">-->
      <!--<div class="hoverBox">-->
      <!--<img :src="codechina" alt="">-->
      <!--</div>-->
      <!--</div>-->
      <!--<img :src="showlist1" alt="" class="logo">-->
      <!--<p class="p1">-->
      <!--全球领先的中文家谱智能编辑软件-->
      <!--</p>-->
      <!--<p class="p1">-->
      <!--与数字出版平台！-->
      <!--</p>-->
      <!--<a class="btn_show" :href="getTokenUrl" target="_blank">进入应用</a>-->
      <!--</div>-->
      <!--<div class="showli showli1">-->
      <!--<div class="tipcode">-->
      <!--<img :src="codeimg" alt="">-->
      <!--<div class="hoverBox">-->
      <!--<img :src="codechina2" alt="">-->
      <!--</div>-->
      <!--</div>-->
      <!--<img :src="showlist2" alt="" class="logo">-->
      <!--<p class="p1">-->
      <!--中文家谱智能阅读器-->
      <!--</p>-->
      <!--<p class="p1" />-->
      <!--<p class="p2">-->
      <!--重新定义数字时代中国人的家谱-->
      <!--</p>-->
      <!--<p class="p2">-->
      <!--让家谱从此大不同！-->
      <!--</p>-->
      <!--</div>-->
      <!--<div class="showli showli1">-->
      <!--<div class="tipcode">-->
      <!--<img :src="codeimg" alt="">-->
      <!--</div>-->
      <!--<img :src="showlist3" alt="" class="logo">-->
      <!--<p class="p1">-->
      <!--连接每个人与每个家，让家触手可及-->
      <!--</p>-->
      <!--<p class="p1" />-->
      <!--<p class="p2">-->
      <!--记录、分享、永久保存-->
      <!--</p>-->
      <!--<p class="p2">-->
      <!--您与家的点点滴滴-->
      <!--</p>-->
      <!--</div>-->
      <!--<div class="showli showli1">-->
      <!--<div class="tipcode">-->
      <!--<img :src="codeimg" alt="">-->
      <!--</div>-->
      <!--<img :src="showlist4" alt="" class="logo">-->
      <!--<p class="p1">-->
      <!--追本溯源，寻根问祖-->
      <!--</p>-->
      <!--<p class="p1" />-->
      <!--<a href="" class="btn_show">进入应用</a>-->
      <!--</div>-->
      <!--<div class="showli showli1">-->
      <!--<div class="tipcode">-->
      <!--<img :src="codeimg" alt="">-->
      <!--</div>-->
      <!--<img :src="showlist5" alt="" class="logo">-->
      <!--<p class="p1">-->
      <!--中文家谱数字出版一站式委托服务-->
      <!--</p>-->
      <!--<p class="p1" />-->
      <!--<a href="" class="btn_show">进入应用</a>-->
      <!--</div>-->
      <!--<div class="showli showli1">-->
      <!--<div class="tipcode">-->
      <!--<img :src="codeimg" alt="">-->
      <!--</div>-->
      <!--<img :src="showlist6" alt="" class="logo">-->
      <!--<p class="p1">-->
      <!--权威的中文家谱数字典藏平台-->
      <!--</p>-->
      <!--<p class="p1" />-->
      <!--<a href="http://localhost:8083/database" target="_blank" class="btn_show">进入应用</a>-->
      <!--</div>-->
      <div class="showlist_list1">
        <div class="showlist_list1_tip">
          我的家谱
        </div>
        <div class="showlist_list1_nav">
          <span class="showlist_list1_span1">谱书 <span class="showlist_list1_span1_num">{{ initData1.type1 }}</span></span>
          <span class="showlist_list1_span1">谱系 <span class="showlist_list1_span1_num">{{ initData1.type3 }}</span></span>
          <span class="showlist_list1_span1 showlist_list1_span_last">谱文 <span class="showlist_list1_span1_num">{{ initData1.type2 }}</span></span>
          <!--<a class="gomaker" :href="getTokenUrl" target="_blank" @click="changeurl">创建家谱</a>-->
          <a class="gomaker" :href="getTokenUrl" target="_blank" @click="changeurl">进入控制台</a>
        </div>
        <mybook />
      </div>
      <div class="showlist_list1 showlist_list2">
        <div class="showlist_list1_tip">
          最近查阅
        </div>
        <div class="showlist_list1_nav">
          <span class="showlist_list1_span1">我的收藏 <span class="showlist_list1_span1_num">{{ initData2.type1 }}</span></span>
          <span class="showlist_list1_span1">我的关注 <span class="showlist_list1_span1_num">{{ initData2.type2 }}</span></span>
          <span class="showlist_list1_span1">我的打赏 <span class="showlist_list1_span1_num">{{ initData2.type3 }}</span></span>
          <span class="showlist_list1_span1 showlist_list1_span_last">我的点评 <span class="showlist_list1_span1_num">{{ initData2.type4 }}</span></span>
          <span class="gomaker goread">进入谱阅
            <img :src="readcode" alt="">
          </span>
        </div>
        <myread v-if="readUserId" :read-user-id="readUserId" />
      </div>
    </div>
    <div v-show="isSeting">
      <div class="top_set">
        <a href="/user?index=0">通行证首页</a>
        <span> >账号管理 </span>
      </div>
      <div class="setContent">
        <div class="leftNav">
          <p :class="currentSet==1?'activeSet':'noavtiveSet'" @click="changeSet(1)">
            <span style="padding-top: 4px;height: 56px;"><svg-icon icon-class="xingxi" class="svg1" /></span><span>账号信息</span>
          </p>
          <p :class="currentSet==2?'activeSet':'noavtiveSet'" @click="changeSet(2)">
            <span style="padding-top: 2px;height: 56px;"><svg-icon icon-class="guanlian" /></span><span>账号关联</span>
          </p>
          <p :class="currentSet==3?'activeSet':'noavtiveSet'" @click="changeSet(3)">
            <span style="padding-top: 2px;height: 56px;"><svg-icon icon-class="mima" class="svg1" /></span><span>密码重置</span>
          </p>
        </div>
        <div v-show="currentSet==1" class="rightNav">
          <div class="tips">
            账号信息
          </div>
          <div class="content">
            <div class="list listimg">
              <span class="lefts">用户头像</span>
              <p class="imgBox">
                <img v-if="userData1.USER_PHOTO" :src="userData1.USER_PHOTO" alt="">
                <img v-if="!userData1.USER_PHOTO" :src="noIMG" alt="">
              </p>
              <span class="changeimg" @click="changeImgBtn"><svg-icon icon-class="bianji" /></span>
            </div>
            <my-upload
              v-model="imgCutUploadParams.show"
              :width="300"
              :height="300"
              :params="imgCutUploadParams.param"
              :url="serverUrl.serverUrl+'/user/updateCmsUserPhoto?'+userID"
              field="file"
              img-format="png"
              @crop-upload-success="cropSuccess"
            />
            <div class="list">
              <span class="lefts">昵称</span>
              <!--<span>{{ userData1.USER_NAME }}</span>-->
              <el-input v-model="userData1.USER_NICK_NAME" placeholder="请输入内容" class="input_type1" />
              <span style="color: #999;margin-left: 20px">长度要求16个字符 (8个汉字以内)</span>
            </div>
            <div class="list">
              <span class="lefts">性别</span>
              <!--<span>{{ userData1.USER_SEX }}</span>-->
              <el-radio v-model="userData1.USER_SEX" label="男">
                男
              </el-radio>
              <el-radio v-model="userData1.USER_SEX" label="女">
                女
              </el-radio>
            </div>
            <div class="list">
              <span class="lefts">出生日期</span>
              <!--<span>{{ userData1.USER_BIRTHDAY }}</span>-->
              <el-date-picker
                v-model="userData1.USER_BIRTHDAY"
                class="input_type1"
                type="date"
                placeholder="出生日期"
              />
            </div>
            <div class="list">
              <span class="lefts">姓氏</span>
              <!--<span>{{ userData1.SURNAME }}</span>-->
              <el-input v-model="userData1.SURNAME" placeholder="请输入姓氏" class="input_type1" />
            </div>
            <div class="list">
              <span class="lefts">个性签名</span>
              <el-input v-model="userData1.SIGNATURE" placeholder="长度要求40个字符（20个汉字以内）" class="input_type2" />
            </div>
            <!--<div class="list">-->
            <!--<span class="lefts">手机号</span>-->
            <!--<span>{{ userData1.USER_MOBILE }}</span>-->
            <!--</div>-->
            <div class="list">
              <span class="lefts">邮箱</span>
              <!--<span>{{ userData1.USER_EMAIL }}</span>-->
              <el-input v-model="userData1.USER_EMAIL" placeholder="请输入邮箱" class="input_type1" />
            </div>
            <div class="list">
              <span class="lefts">所在地区</span>
              <!--<span>{{ userData1.USER_COUNTRY|changeUndefind }}{{ userData1.USER_PROVINCE |changeUndefind }}{{ userData1.USER_CITY |changeUndefind }}</span>-->
              <el-select v-model="userData1.USER_COUNTRY" placeholder="国家" class="selectInput" @change="changeCountry">
                <el-option
                  v-for="item in countryData"
                  :key="item.value"
                  :label="item.label"
                  :value="item.label"
                />
              </el-select>
              <el-select v-model="userData1.USER_PROVINCE" placeholder="省/市" class="selectInput" @change="changeProvince">
                <el-option
                  v-for="item in provinceData"
                  :key="item.value"
                  :label="item.label"
                  :value="item.label"
                />
              </el-select>
              <el-select v-model="userData1.USER_CITY" placeholder="县/区" class="selectInput">
                <el-option
                  v-for="item in cityData"
                  :key="item.value"
                  :label="item.label"
                  :value="item.label"
                />
              </el-select>
            </div>
            <div class="list">
              <span class="lefts">详细地址</span>
              <!--<span>{{ userData1.USER_ADDRESS }}</span>-->
              <el-input v-model="userData1.USER_ADDRESS" placeholder="长度要求40个字符（20个汉字以内）" class="input_type2" />
            </div>
          </div>
          <div class="errormsg">
            <span v-if="iserror.status">{{ iserror.message }}</span>
          </div>
          <div class="btnchange">
            <span @click="handerXiuGai">保存修改</span>
          </div>
        </div>
        <div v-show="currentSet==2" class="rightNav2">
          <div class="tips">
            我绑定的账号
          </div>
          <div class="rightNav2_content">
            <p class="rightNav2_p">
              <span class="iconbgc1">
                <svg-icon icon-class="phone" />
              </span>
              <span>手机：</span>
              <span style="color: #333333">{{ userData1.USER_MOBILE }}</span>
              <span v-if="userData1.USER_MOBILE" class="usercount_text">已认证</span>
              <span class="btn_user" @click="handelPhone">更换号码</span>
            </p>
            <p class="rightNav2_p">
              <span class="iconbgc2">
                <svg-icon icon-class="wxicon" />
              </span>
              <span>微信：</span>
              <span style="color: #333333">{{ userData1.USER_MOBILE }}</span>
              <span v-if="userData1.USER_MOBILE" class="usercount_text">已认证</span>
              <span class="btn_user" @click="handelwx">更换微信</span>
            </p>
          </div>
          <div class="tips">
            已开通应用
          </div>
          <div class="rightNav2_content2">
            <a class="lis" style="margin-right: 18px;" :href="getTokenUrl" target="_blank" @click="changeurl">
              <img :src="lis1" alt="" style="width: 185px;height: 71px;margin-top: 3px;border-radius: 5px;">
            </a>
            <div class="lis lis2 lis3" style="position: relative">
              <img :src="lis2" alt="">
              <img :src="codechina2" alt="" class="codepuyue">
            </div>
            <a class="lis lis2" href="http://maker.pengzushijia.com/project/allDataBase" target="_blank">
              <img :src="lis3" alt="">
            </a>
            <!--<div class="lis lis2">-->
            <!--<img :src="lis4" alt="">-->
            <!--</div>-->
          </div>
        </div>
        <div v-show="currentSet==3" class="rightNav2 rightNav3">
          <div class="tips">
            重置密码
          </div>
          <div class="input_pw">
            <span>原始密码</span>
            <div class="input_div">
              <el-input v-model="password1" placeholder="请输入原始密码" show-password class="pw_change" />
            </div>
          </div>
          <div class="input_pw">
            <span>新密码</span>
            <div class="input_div">
              <el-input v-model="password2" placeholder="请输入原始密码" show-password class="pw_change" />
            </div>
          </div>
          <div class="input_pw">
            <span>确认密码</span>
            <div class="input_div">
              <el-input v-model="password3" placeholder="请输入原始密码" show-password class="pw_change" />
            </div>
          </div>
          <div class="btnBox">
            <span @click="changepwd">保存修改</span>
          </div>
        </div>
      </div>
    </div>
    <div v-show="changePhone" class="box_phone">
      <div class="content">
        <div class="topname">
          <span>更改手机号</span><span class="topname_right" @click="goquxiao">X</span>
        </div>
        <div class="titles">
          <p class="p2" style="font-size: 16px;text-align: center;color: red">
            更改后，您当前登录的账号将绑定新的手机号，请谨慎操作
          </p>
        </div>
        <div class="jiebanContent">
          <span>新手机号</span>
          <div class="inputBox_jieban">
            <el-input v-model="newPhone" placeholder="请输入新手机号" type="text" />
          </div>
        </div>
        <div class="jiebanContent">
          <span>验证码</span>
          <div class="inputBox_jieban">
            <el-input v-model="PhoneCode" placeholder="请输入验证码" type="text" style="width: 300px;" />
            <div class="yzmBtns" style="    float: right;">
              <div v-show="isVcodeBtn" class="getVcodeBtn" @click="getVcodess">
                获取验证码
              </div>
              <div v-show="!isVcodeBtn" class="getVcodeBtn num">
                重新发送 <span style=" display: inline;margin-left: 0">({{ count }})</span>
              </div>
            </div>
          </div>
        </div>
        <el-button type="primary" class="submitbtn" @click="gojiebang">
          确 定
        </el-button>
        <el-button class="quxiaobtn" @click="goquxiao">
          取 消
        </el-button>
      </div>
    </div>
    <div v-show="ispayShow">
      <payCenter />
    </div>
  </div>
</template>

<script>
// import pagination from '@/components/userCenter/pagination.vue'
import { getInitMsg, loadIndex, changeUserMsg, getVcode, changePhone, getUpdateBindingUrl, changePassWord, userOutLogin } from '@/api/api.js'
import { deleteWeiXinUser, addWeiXinUserUrl, IsPhoneCode } from '@/api/login.js'
import payCenter from '@/components/passcardNav/payCenter.vue'
import myUpload from '@/components/imgCutUpload'
import dataJson from '@/utils/as.js'
import { addLoginState } from '@/api/login.js'
import { ssoUserLogin } from '@/api/api.js'
import { findUserFamilyTreeSize, findUserCollectionSize, findPassportFollowSize, findUserRewardSize, findUserMessageSize } from '@/api/api.js'
import mybook from '@/components/passcardNav/myBook.vue'
import myread from '@/components/passcardNav/myread.vue'

export default {
  components: {
    myUpload, payCenter, mybook, myread
  },
  inject: ['reload'],
  data() {
    return {
      codechina2: require('@/static/readerCode_02.png'),
      readcode: require('@/static/readerCode_02.png'),
      readUserId: '',
      passportid: '',
      initData1: {
        type1: 0,
        type2: 0,
        type3: 0
      },
      initData2: {
        type1: 0,
        type2: 0,
        type3: 0,
        type4: 0
      },
      getTokenUrl: '',
      ispayShow: false,
      codechina: require('@/static/mfbcode_chinagen.png'),
      // codechina2: require('@/static/puyucode_chinagen.png'),
      lis1: require('@/static/pengshows.png'),
      lis2: require('@/static/puyueicon.png'),
      lis3: require('@/static/gejiicon.png'),
      lis4: require('@/static/familyicon.png'),
      showlist1: require('@/static/showlist1.png'),
      showlist2: require('@/static/showlist2.png'),
      showlist3: require('@/static/showlist3.png'),
      showlist4: require('@/static/showlist4.png'),
      showlist5: require('@/static/showlist5.png'),
      showlist6: require('@/static/showlist6.png'),
      codeimg: require('@/static/codeimg.png'),
      geticon: require('@/static/geticon.png'),
      userID: '',
      userData1: {},
      userData2: {},
      isSeting: false,
      currentSet: 1,
      imgCutUploadParams: {
        show: false,
        param: {
          userId: ''
        },
        headers: {
          smail: '*_~'
        },
        imgDataUrl: '' // base64地址存储位置
      },
      noIMG: require('@/static/usuerDefault.png'),
      issubmit: false,
      countryData: [],
      provinceData: [],
      cityData: [],
      iserror: {
        status: false,
        message: ''
      },
      changePhone: false,
      newPhone: '',
      PhoneCode: '',
      isVcodeBtn: true,
      count: 60,
      dialog: false,
      password1: '',
      password2: '',
      password3: ''
    }
    // /初始化数据
  },
  mounted() {
    this.newInit()
    ssoUserLogin().then(res => {
      if (res.data.userId) {
        this.setloca('userid', res.data.userId, 7200)
        localStorage.removeItem('unionid')
        this.userID = res.data.userId
        this.imgCutUploadParams.param.userId = this.userID
        this.fetchData()
      } else {
        localStorage.removeItem('userid')
      }
    })
    this.countryData = dataJson.dataJson
  },
  methods: {
    changeurl() {
      this.handeGo()
    },
    fetchData() {
      if (this.userID) {
        getInitMsg({ userId: this.userID }).then(res => {
          this.readUserId = res.data.readerUsrId
          this.userData1 = res.data
          if (this.userData1.USER_SEX == 1) {
            this.userData1.USER_SEX = '男'
          }
          if (this.userData1.USER_SEX == 2) {
            this.userData1.USER_SEX = '女'
          }
          this.userData1.userArea = []
          // 省份
          for (var i = 0; i < this.countryData.length; i++) {
            if (this.countryData[i].label == this.userData1.USER_COUNTRY) {
              if (this.countryData[i].label == '中国') {
                this.provinceData = this.countryData[i].children
              } else {
                this.provinceData = this.countryData[i].children.children
              }
            }
          }
          // 地区
          if (this.provinceData.length > 0) {
            for (var j = 0; j < this.provinceData.length; j++) {
              if (this.provinceData[j].label == this.userData1.USER_PROVINCE) {
                this.cityData = this.provinceData[j].children
              }
            }
          }
          loadIndex().then(res2 => {
            this.userData2 = res2.data
            this.setloca('passportid', res2.data.passportUser.passportid, 7200)
            this.setloca('unionid', res2.data.passportUser.unionid, 7200)
            this.unionid = res2.data.passportUser.unionid
            this.passportid = res2.data.passportUser.passportid
            this.newInit2()
            this.handeGo()
          })
        })
      }
    },
    changeCountry(value) {
      this.userData1.USER_PROVINCE = ''
      this.userData1.USER_CITY = ''
      this.provinceData = []
      this.cityData = []
      for (var i = 0; i < this.countryData.length; i++) {
        if (this.countryData[i].label == value) {
          if (this.countryData[i].label == '中国') {
            this.provinceData = this.countryData[i].children
          } else {
            this.provinceData = this.countryData[i].children.children
          }
        }
      }
      if (this.provinceData.length > 0) {
        for (var j = 0; j < this.provinceData.length; j++) {
          if (this.provinceData[j].label == this.userData1.USER_PROVINCE) {
            this.cityData = this.provinceData[j].children
          }
        }
      }
    },
    changeProvince(value) {
      this.cityData = []
      this.userData1.USER_CITY = ''
      if (this.provinceData.length > 0) {
        for (var j = 0; j < this.provinceData.length; j++) {
          if (this.provinceData[j].label == value) {
            this.cityData = this.provinceData[j].children
          }
        }
      }
    },

    handelPhone() {
      this.changePhone = true
    },
    goquxiao() {
      this.changePhone = false
      this.newPhone = ''
      this.PhoneCode = ''
      this.isVcodeBtn = true
      this.count = 60
    },
    gojiebang: function() {
      if (this.newPhone == '') {
        this.$message.error('请输入手机号')
        return false
      }
      if (this.PhoneCode == '') {
        this.$message.error('请输入验证码')
        return false
      }
      IsPhoneCode({
        phone: this.newPhone,
        code: this.PhoneCode
      }).then(res => {
        if (res.data) {
          changePhone({
            phone: this.newPhone,
            validationCode: this.PhoneCode,
            userId: this.userID
          }).then(res => {
            if (res.data.type == '0') {
              this.$message({
                message: '手机号更改成功',
                type: 'success'
              })
            } else {
              this.$message.error('修改失败')
            }
            this.changePhone = false
          })
        } else {
          this.$message.error('该手机号已绑定')
        }
      })
    },
    handelwx() {
      var is_mobi = navigator.userAgent.toLowerCase().match(/(ipod|ipad|iphone|android|coolpad|mmp|smartphone|midp|wap|xoom|symbian|j2me|blackberry|wince)/i) != null
      var left = (window.screen.width - 800) / 2
      var top = (window.screen.height - 600) / 2
      if (is_mobi) {
        getUpdateBindingUrl({ loginType: 'app' }).then(res => {
          window.open(res.data.url)
        })
      } else {
        getUpdateBindingUrl().then(res => {
          window.open(res.data.url, '_blank', 'toolbar=yes, location=yes, directories=no, status=no, menubar=yes, scrollbars=yes, resizable=no, copyhistory=yes, left=' + left + ', top=' + top + ', width=' + 800 + ', height=' + 600)
        })
      }
    },
    getVcodess() {
      this.PhoneCode = ''
      if (!(/^1[34578]\d{9}$/.test(this.newPhone))) {
        this.$message({
          message: '请正确输入手机号',
          type: 'error',
          duration: 2000
        })
      } else {
        IsPhoneCode({
          phone: this.newPhone
        }).then(res => {
          if (res.data) {
            var obj = {}
            obj.phone = this.newPhone
            obj.codeType = '3'
            this.isVcodeBtn = false
            var $this = this
            var timers = setInterval(() => {
              $this.count--
              if ($this.count <= 0) {
                $this.isVcodeBtn = true
                clearInterval(timers)
              }
            }, 1000)
            getVcode(obj).then(res => {
              if (res.code == 200) {
                this.$message({
                  message: '短信验证已发送',
                  type: 'success',
                  duration: 2000
                })
              }
            })
          } else {
            this.$message.error('该手机号已绑定')
          }
        })
      }
    },
    changepwd() {
      if (this.password2 === this.password3) {
        var obj = {}
        obj.userId = this.userID
        obj.originalPassword = this.password1
        obj.newPssword = this.password2
        changePassWord(obj).then(res => {
          // console.log(res.data.success)
          if (res.data.success === true) {
            this.$message({
              message: '修改成功',
              type: 'success'
            })
            this.password1 = ''
            this.password2 = ''
            this.password3 = ''
          } else {
            this.$message.error(res.data.msg)
          }
        })
      } else {
        this.$message.error('两次密码不一致')
      }
    },
    goseting() {
      this.isSeting = true
    },
    changeSet(index) {
      this.currentSet = index
    },
    changeImgBtn: function() {
      this.imgCutUploadParams.show = true
    },
    cropSuccess(resData) {
      this.userData1.USER_PHOTO = resData.data.contentPath
    },
    handerXiuGai: function() {
      if (!this.issubmit) {
        this.issubmit = true
      }
      if (this.issubmit) {
        if (!this.userData1.USER_NICK_NAME || this.userData1.USER_NICK_NAME.length > 8) {
          this.iserror = {
            status: true,
            message: '昵称长度不合法'
          }
          this.issubmit = false
          return ''
        }
        if (this.userData1.SIGNATURE) {
          if (this.userData1.SIGNATURE.length > 20) {
            this.iserror = {
              status: true,
              message: '签名长度不合法'
            }
            this.issubmit = false
            return ''
          }
        }
        if (this.userData1.USER_ADDRESS) {
          if (this.userData1.USER_ADDRESS.length > 20) {
            this.iserror = {
              status: true,
              message: '详细地址长度不合法'
            }
            this.issubmit = false
            return ''
          }
        }
        var obj = {}
        obj.userId = this.userID
        if (this.userData1.USER_SEX == '男') {
          obj.userSex = 1
        }
        if (this.userData1.USER_SEX == '女') {
          obj.userSex = 2
        }
        if (this.userData1.USER_BIRTHDAY) {
          this.userData1.USER_BIRTHDAY = new Date(this.userData1.USER_BIRTHDAY)
          var year = this.userData1.USER_BIRTHDAY.getFullYear()
          var month = (this.userData1.USER_BIRTHDAY.getMonth() + 1).toString()
          var day = (this.userData1.USER_BIRTHDAY.getDate()).toString()
          obj.birthdate = year + '-' + month + '-' + day
          // obj.birthdate = this.userData.USER_BIRTHDAY
        }
        obj.userName = this.userData1.USER_NICK_NAME
        obj.surName = this.userData1.SURNAME
        obj.signature = this.userData1.SIGNATURE
        obj.userEmail = this.userData1.USER_EMAIL
        obj.country = this.userData1.USER_COUNTRY
        obj.province = this.userData1.USER_PROVINCE
        obj.city = this.userData1.USER_CITY
        obj.address = this.userData1.USER_ADDRESS
        changeUserMsg(obj).then(res => {
          this.iserror = {
            status: false,
            message: ''
          }
          this.issubmit = false
          if (res.data == true) {
            this.$message({
              message: '修改成功',
              type: 'success'
            })
            // this.showshadow = false
            // this.reload()
          }
        })
      }
    },
    isPay: function() {
      this.ispayShow = true
    },
    tixian() {
      this.$message({
        type: 'warning',
        message: '该功能暂未开放，敬请期待'
      })
    },
    outlogin() {
      localStorage.removeItem('username')
      localStorage.removeItem('userid')
      localStorage.removeItem('passportid')
      localStorage.removeItem('unionid')
      localStorage.removeItem('readerUsrId')
      userOutLogin().then(res => {
        this.$message({
          showClose: true,
          message: '您已成功退出登录',
          type: 'success'
        })
        this.$router.replace('/home')
        // window.location.href = 'http://www.chinagen.cn/home'
      })
    },
    handeGo(url) {
      url = 'http://maker.pengzushijia.com/ssoLogin/ssoLogin?token='
      // url = 'http://maker.myfamilybook.cn/ssoLogin/ssoLogin?token='
      if (this.getLoca('userid')) {
        addLoginState({ unionid: this.getLoca('unionid') }).then(res => {
          if (res.data.errcode === '0') {
            var nurl = url + res.data.token
            this.getTokenUrl = nurl
          }
          if (res.data.errcode == '1') {
            this.$alert('您的登录信息已经过期，请重新登录', '提示', {
              confirmButtonText: '确定',
              callback: action => {
                this.$router.push('/login')
              }
            })
          }
        })
      } else {
        this.$alert('您的登录信息已经过期，请重新登录', '提示', {
          confirmButtonText: '确定',
          callback: action => {
            this.$router.push('/login')
          }
        })
        localStorage.removeItem('userid')
      }
    },
    newInit() {
      findUserFamilyTreeSize().then(res => {
        for (var i = 0; i < res.data.length; i++) {
          if (res.data[i].RESTYPE == 1) {
            this.initData1.type1 = res.data[i].COUNT
          }
          if (res.data[i].RESTYPE == 2) {
            this.initData1.type2 = res.data[i].COUNT
          }
          if (res.data[i].RESTYPE == 3) {
            this.initData1.type3 = res.data[i].COUNT
          }
        }
      })
    },
    newInit2() {
      findUserCollectionSize({ passportid: this.passportid }).then(res => {
        this.initData2.type1 = res.data.count
      })
      findPassportFollowSize({ unionid: this.unionid }).then(res => {
        this.initData2.type2 = res.data.count
      })
      findUserRewardSize({ readUserId: this.readUserId }).then(res => {
        this.initData2.type3 = res.data.REWARD_AMOUNT
      })
      findUserMessageSize({ passportid: this.passportid }).then(res => {
        this.initData2.type4 = res.data.count
      })
    }
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
  .codepuyue{
    position: absolute;
    top: -203px;
    left: -5px;
    z-index: 2;
    display: none;
  }
  .lis3:hover > .codepuyue{
    display: inline-block;
  }
    .showlist_list1{
        border: 1px solid #E1E8F1;
        overflow: hidden;
        background-color: #fff;
        padding: 20px 20px;
        .showlist_list1_tip{
            display: inline-block;
            padding-left: 7px;
            border-left: 3px solid #E0466E;
            height: 17px;
            line-height: 17px;
            margin-top: 10px;
            font-size: 18px;
        }
        .showlist_list1_nav{
            height: auto;
            margin-top: 20px;
            margin-bottom: 20px;
            line-height: 32px;
            .showlist_list1_span1{
                font-size: 16px;
                color: #999;
                display: inline-block;
                min-width: 100px;
                border-right: 1px solid #DDDDDD;
                margin-right: 20px;
                padding-right: 10px;
            }
            .showlist_list1_span_last{
                border: none;
            }
            .showlist_list1_span1_num{
                font-size: 22px;
                color: #FF6200;
            }
            .gomaker{
                background-color: #F9F9F9;
                width: 88px;
                height: 32px;
                line-height: 32px;
                float: right;
                margin-left: 30px;
                border: 1px solid #999;
                text-align: center;
                border-radius: 2px;
                &:hover{
                    color:  #FF6200;
                    border: 1px solid #FF6200;
                }
            }
            .goread{
                cursor: pointer;
                position: relative;
                img{
                    position: absolute;
                    top: -67px;
                    left: -189px;
                    z-index: 2;
                    display: none;
                }
            }
            .goread:hover >img{
                display: inline-block;
            }
        }
    }
    .showlist_list2{
        margin-top: 20px;
    }
    .z1200{
        width: 1200px;
        margin: 0 auto;
    }
    .homeContent{
        overflow: hidden;
        .topshow{
            margin-top: 40px;
            height: 178px;
            width: 1198px;
            border: 1px solid #E1E8F1;
            font-size: 0;
            .myMsg1{
                width: 520px;
                height: 178px;
                background-color: #fff;
                border-right: 1px solid #E1E8F1;
                display: inline-block;
                vertical-align: top;
                .userImg{
                    width: 86px;
                    height: 86px;
                    display: inline-block;
                    vertical-align: top;
                    margin-top: 46px;
                    margin-left: 20px;
                    img{
                        border-radius: 50%;
                        width: 86px;
                        height: 86px;
                    }
                }
                .tipname{
                    display: inline-block;
                    width: 370px;
                    vertical-align: top;
                    height: 128px;
                    margin-left: 25px;
                    padding: 25px 0;
                    p{
                        font-size: 18px;
                    }
                    .settingBtn{
                        float: right;
                        color: #666666;
                        font-size: 14px;
                        cursor: pointer;
                        svg{
                            color: #E0466E;
                            margin-right: 10px;
                            font-size: 18px;
                        }
                    }
                    .usertag{
                        margin: 22px 0;
                        height: 35px;
                        font-size: 14px;
                        color: #999999;
                        overflow:hidden;
                        text-overflow:ellipsis;
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 2;
                        overflow: hidden;
                    }
                    .usercount{
                        height: 25px;
                        overflow: hidden;
                        span{
                            font-size: 14px;
                            color: #666666;
                            display: inline-block;
                            svg{
                                color: #ffffff;
                                font-size: 18px;
                            }
                        }
                        .usercount_text{
                            margin: 0 10px;
                            font-size: 14px;
                            color: #333333;
                        }
                        .iconbgc1{
                            display: inline-block;
                            width: 25px;
                            height: 25px;
                            background-color: #5AA0FD;
                            border-radius: 50%;
                            line-height: 25px;
                            text-align: center;
                        }
                        .iconbgc2{
                            display: inline-block;
                            width: 25px;
                            height: 25px;
                            background-color: #259B24;
                            border-radius: 50%;
                            line-height: 25px;
                            text-align: center;
                        }
                        .btn_user{
                            color: #5AA0FD;
                            font-size: 12px;
                            cursor: pointer;
                        }
                    }
                }
            }
            .myMsg2{
                width: 338px;
                height: 178px;
                border-right: 1px solid #E1E8F1;
                display: inline-block;
                vertical-align: top;
                .myMsg2_p1{
                    display: inline-block;
                    width: 100%;
                    height: 115px;
                    background-color: #fff;
                    border-bottom: 1px solid #F0F3F8;
                    vertical-align: top;
                    .lefticon{
                        height: 60px;
                        margin-left: 48px;
                        display: inline-block;
                        margin-top: 30px;
                        width: 40px;
                        text-align: center;
                        font-size: 16px;
                        svg{
                            font-size: 40px;
                            color: #E0466E;
                        }
                    }
                    .rightnum{
                        height: 60px;
                        display: inline-block;
                        margin-top: 30px;
                        width: 170px;
                        margin-left: 78px;
                        vertical-align: top;
                        .rightnum_p{
                            font-size: 14px;
                            color: #999999;
                            .num{
                                font-size: 18px;
                                color: #333333;
                                margin-left: 5px;
                            }
                        }
                        .rightnum_p_2{
                            margin-top: 12px;
                        }
                    }
                }
                .myMsg2_p2{
                    height: 62px;
                    text-align: center;
                    padding: 0 20px;
                    width: 298px;
                    line-height: 62px;
                    span{
                        color: #999;
                    }
                    .moneynum{
                        color: #E0466E;
                        font-size: 18px;
                    }
                    .moneybtn{
                        background-color: #F3F8FF;
                        padding: 3px 10px;
                        border: 1px solid #BCD4F5;
                        color: #666666;
                        border-radius: 3px;
                        cursor: pointer;
                    }
                    .moneybtn1{
                        margin-left: 38px;
                    }
                    .moneybtn2{
                        margin-left: 13px;
                    }
                }
            }
            .myMsg3{
                width: 338px;
                height: 178px;
                display: inline-block;
                vertical-align: top;
                .myMsg2_p1{
                    display: inline-block;
                    width: 100%;
                    height: 115px;
                    background-color: #fff;
                    border-bottom: 1px solid #F0F3F8;
                    vertical-align: top;
                    .lefticon{
                        height: 60px;
                        margin-left: 48px;
                        display: inline-block;
                        margin-top: 30px;
                        width: 40px;
                        text-align: center;
                        font-size: 16px;
                        svg{
                            font-size: 40px;
                            color: #E0466E;
                        }
                    }
                    .rightnum{
                        height: 60px;
                        display: inline-block;
                        margin-top: 30px;
                        width: 170px;
                        margin-left: 78px;
                        vertical-align: top;
                        .rightnum_p{
                            font-size: 14px;
                            color: #999999;
                            .num{
                                font-size: 18px;
                                color: #333333;
                                margin-left: 5px;
                            }
                        }
                        .rightnum_p_2{
                            margin-top: 12px;
                        }
                    }
                }
                .myMsg2_p2{
                    height: 62px;
                    text-align: center;
                    padding: 0 20px;
                    width: 298px;
                    line-height: 62px;
                    span{
                        color: #999;
                    }
                    .moneynum{
                        color: #E0466E;
                        font-size: 18px;
                    }
                    .moneybtn{
                        background-color: #F3F8FF;
                        padding: 3px 10px;
                        border: 1px solid #BCD4F5;
                        color: #666666;
                        border-radius: 3px;
                        cursor: pointer;
                    }
                    .moneybtn1{
                        margin-left: 38px;
                    }
                    .moneybtn2{
                        margin-left: 13px;
                    }
                }
                .myMsg3_p3{
                    display: inline-block;
                    margin-left: 70px;
                    img{
                        width: 18px;
                        height: 16px;
                    }
                    span{
                        margin-left: 5px;
                    }
                }
            }
        }
        .showlist{
            overflow: hidden;
            margin-top: 10px;
            padding-bottom: 80px;
            .showli{
                margin-top: 30px;
                background-color: #fff;
                display: inline-block;
                width: 380px;
                height: 240px;
                position: relative;
                text-align: center;
                margin-right: 30px;
                vertical-align: top;
                overflow: hidden;
                .tipcode{
                    position: absolute;
                    top: 0;
                    right: 0;
                    display: inline-block;
                    cursor: pointer;
                    z-index: 2;
                    img{
                        width: 54px;
                        height: 54px;
                    }
                }
                .hoverBox{
                    position: absolute;
                    z-index: 3;
                    height: 240px;
                    line-height: 240px;
                    text-align: center;
                    width: 380px;
                    display: inline-block;
                    top: 240px;
                    left: -326px;
                    transition: 1s;
                    background-color: #F3F3F4;
                    img{
                        width: 132px;
                        height: 132px;
                        vertical-align: middle;
                    }
                }
                .tipcode:hover > .hoverBox{
                    top: 0;
                }
                .logo{
                    margin-top: 40px;
                    margin-bottom: 25px;
                }
                .p1{
                    height: 20px;
                    line-height: 20px;
                    font-size: 16px;
                    color: #333333;
                    text-align: center;
                }
                .p2{
                    font-size: 14px;
                    color: #666666;
                    height: 25px;
                    line-height: 25px;
                }
                .btn_show{
                    display: inline-block;
                    width: 218px;
                    height: 34px;
                    line-height: 34px;
                    border: 1px solid #E0466E;
                    color: #E0466E;
                    font-size: 14px;
                    margin-top: 18px;
                    cursor: pointer;
                    &:hover{
                        color: #ffffff;
                        background: #E0466E;
                    }
                }
            }
            .showli:hover{
                box-shadow: 1px 1px 1px 1px hsla(0,0%,0%,.05);
            }
            .showli:nth-child(3n){
                margin-right: 0;
            }
        }
    }
    .top_set{
        height: 80px;
        line-height: 80px;
        text-align: left;
        font-size: 14px;
        a{
            color: #999999;
        }
        span{
            color: #666666;
        }
    }
    .leftNav{
        height: 180px;
        background-color: #fff;
        width: 260px;
        display: inline-block;
        vertical-align: top;
        margin-right: 40px;
        font-size: 16px;
        svg{
            margin-right: 10px;
            font-size: 20px;
        }
        span{
            display: inline-block;
            vertical-align: top;
        }
        .svg1{
            font-size: 25px;
        }
        .noavtiveSet{
            cursor: pointer;
            height: 60px;
            line-height: 60px;
            background-color: #fff;
            padding-left: 30px;
            color: #333;
            svg{
                color: #666;
            }
        }
        .activeSet{
            cursor: pointer;
            height: 60px;
            line-height: 60px;
            background-color: #FAFCFF;
            padding-left: 30px;
            color: #E0466E;
            svg{
                color: #E0466E;
            }
        }
    }
    .rightNav{
        height: 780px;
        width: 840px;
        display: inline-block;
        vertical-align: top;
        background-color: #fff;
        padding: 0 30px;
        .tips{
            display: inline-block;
            padding-left: 7px;
            border-left: 3px solid #E0466E;
            height: 17px;
            line-height: 17px;
            margin-top: 30px;
            font-size: 18px;
        }
        .content{
            margin-left: 10px;
            margin-top: 24px;
            .listimg{
                height: 78px;
                line-height: 78px;
                margin-bottom: 20px;
                .imgBox{
                    display: inline-block;
                    height: 78px;
                    width: 78px;
                    border-radius: 50%;
                    vertical-align: top;
                    font-size: 0;
                    img{
                        height: 78px;
                        width: 78px;
                        border-radius: 50%;
                    }
                }
                .changeimg{
                    color: #999999;
                    margin-left: 20px;
                    cursor: pointer;
                    &:hover{
                        color: #E0466E;
                    }
                    svg{
                        font-size: 20px;
                        margin-top: 20px;
                    }
                }
            }
        }
        .list{
            height: 55px;
            line-height: 55px;
            padding-left: 190px;
            span{
                font-size: 14px;
            }
            .lefts{
                display: inline-block;
                width: 60px;
                text-align: right;
                color: #808080;
                font-size: 14px;
                line-height: 32px;
                margin-right: 25px;
            }
            .values{
                color: #333333;
                font-size: 14px;
                font-weight: 500;
                display: inline-block;
                height: 32px;
                line-height: 32px;
            }
            .btn_change_pwd{
                color: #ed4040;
                margin-left: 20px;
                display: inline-block;
                height: 32px;
                line-height: 32px;
                cursor: pointer;
            }
            .btn_change_pho{
                color: #ed4040;
                margin-left: 20px;
                display: inline-block;
                height: 32px;
                line-height: 32px;
                cursor: pointer;
            }
            .btn_jiebang{
                color: #ed4040;
                cursor: pointer;
                padding-left:8px;
                border-left: 2px solid #a19d9e;
                margin-left: 10px;
            }
        }
        .input_type1{
            width: 198px;
            height: 32px;
        }
        .input_type2{
            width: 438px;
            height: 32px;
        }
        .btnchange{
            text-align: center;
            margin-top: 25px;
            span{
                display: inline-block;
                width: 100px;
                height: 38px;
                background-color: #E0466E;
                color: #ffffff;
                font-size: 14px;
                text-align: center;
                line-height: 38px;
                cursor: pointer;
            }
        }
    }
    .rightNav2{
        height: 500px;
        width: 840px;
        display: inline-block;
        vertical-align: top;
        background-color: #fff;
        padding: 0 30px;
        margin-bottom: 115px;
        .tips{
            display: inline-block;
            padding-left: 7px;
            border-left: 3px solid #E0466E;
            height: 17px;
            line-height: 17px;
            margin-top: 30px;
            font-size: 18px;
        }
        .rightNav2_content{
            overflow: hidden;
            padding-top: 25px;
            padding-bottom: 25px;
            .rightNav2_p{
                margin-bottom: 25px;
                padding-left: 30px;
            }
            span{
                font-size: 16px;
                color: #999;
            }
            .iconbgc1{
                display: inline-block;
                width: 25px;
                height: 25px;
                background-color: #5AA0FD;
                border-radius: 50%;
                line-height: 25px;
                text-align: center;
                margin-right: 16px;
                svg{
                    color: #ffffff;
                    font-size: 18px;
                }
            }
            .iconbgc2{
                display: inline-block;
                width: 25px;
                height: 25px;
                background-color: #259B24;
                border-radius: 50%;
                line-height: 25px;
                text-align: center;
                margin-right: 16px;
                svg{
                    color: #ffffff;
                    font-size: 18px;
                }
            }
            .usercount_text{
                margin-left: 65px;
                color: #333;
                margin-right: 30px;
                font-size: 14px;
            }
            .btn_user{
                padding: 2px 10px;
                border: 1px solid #E5E5E5;
                color: #5AA0FD;
                font-size: 14px;
                border-radius: 3px;
                cursor: pointer;
            }
        }
        .rightNav2_content2{
            padding-top: 25px;
            .lis{
                display: inline-block;
                vertical-align: top;
                width: 170px;
                height: 80px;
                margin-left: 33px;
            }
          .lis2{
            margin-left: 18px;
          }
        }

    }
    .rightNav3{
        .tips{
            margin-bottom: 45px;
        }
        .input_pw{
            padding: 10px 250px;
            height: 40px;
            line-height: 40px;
            width: 400px;
            span{
                display: inline-block;
                height: 40px;
                width: 60px;
                vertical-align: top;
                margin-right: 20px;
                text-align: right;
            }
            .input_div{
                display: inline-block;
                width: 299px;
                height: 40px;
                vertical-align: top;
            }
            .pw_change{
                width: 299px;
                height: 40px;
            }
        }
        .btnBox{
            text-align: center;
            overflow: hidden;
            margin-top: 30px;
            span{
                display: inline-block;
                width: 100px;
                height: 38px;
                line-height: 38px;
                text-align: center;
                color: #ffffff;
                background-color: #E0466E;
                font-size: 14px;
                cursor: pointer;
            }
        }
    }

    .selectInput{
        width: 100px;
        margin-right: 10px;
    }
    .errormsg{
        height: 30px;
        line-height: 30px;
        text-align: center;
        color: #ed4040;
        font-size: 16px;
    }

    .box_phone{
        background-color: rgba(0,0,0,.5);
        position: fixed;
        height: 100vh;
        width: 100%;
        z-index: 200;
        top: 0;
        left: 0;
        .content{
            position: absolute;
            top:50%;
            left: 50%;
            height: 350px;
            width: 600px;
            background-color: #fff;
            margin-top: -200px;
            margin-left: -300px;
            z-index: 201;
            .quxiaobtn{
                margin-top: 20px;
                float: right;
                margin-right: 20px;
            }
            .submitbtn{
                margin-top: 20px;
                float: right;
                margin-right: 20px;
            }
        }

    }
    .getVcodeBtn{
        width: 100px;
        display: inline-block;
        background-color: #E0466E;
        margin-left: 10px;
        border-radius: 5px;
        text-align: center;
        color: #ffffff;
        font-size: 12px;
        cursor: pointer;
        line-height: 40px;
    }
    .num{
        background-color: #fff;
        color: #a19d9e;
        cursor: not-allowed;
        span{
            font-size: 12px;
            color: #a19d9e;
        }
    }
    .topname{
        height: 55px;
        padding: 0 20px;
        line-height: 55px;
        font-size: 16px;
        .topname_right{
            float:right;
            cursor: pointer;
            &:hover{
                color: #ed4040;
            }
        }
    }
    .jiebanContent{
        overflow: hidden;
        height: 40px;
        margin-top: 40px;
        span{
            display: inline-block;
            width: 50px;
            height: 40px;
            vertical-align: top;
            line-height: 40px;
            margin-left: 40px;
        }
    }
    .inputBox_jieban{
        display: inline-block;
        width: 425px;
        height: 40px;
        overflow: hidden;
        margin-left: 20px;
    }
</style>

<!--手机端样式-->
<style rel="stylesheet/scss" lang="scss" scoped>
    @media screen and (max-width: 750px) {

    }
</style>

